import { call, put, takeEvery } from 'redux-saga/effects';
import { login, loginSuccess, loginFailure } from '../../actions/Login';

import { loginRequest } from '../../../api/requests/Login/loginRequest';

import history from '../../../../../common/history';
import * as URLs from '../../../../../common/constants/systemUrls';

function* loginSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(loginRequest, payload);
    yield put(loginSuccess(response));
    history.push('/' + URLs.AUTHORIZATION + '/' + URLs.CHECK_CODE);
  } catch (err) {
    yield put(loginFailure(err));
  }
}

export function* loginWatcher() {
  //LOGIN Первый ввод номера телефона
  yield takeEvery(login.toString(), loginSaga);
}
